module.exports = __webpack_public_path__ + "img/vision.53a609f2.svg";